const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return {
    serialized: JSON.stringify(obj),
    formData,
  };
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function escapeHtml(unsafe) {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  setTimeout(() => {
    elementToFocus.focus();
  }, 100);

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function fetchGetConfig(type = "json") {
  return {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.querySelector("cart-drawer-outland");
  const headerCartButton = document.querySelector(".header-action-cart");

  headerCartButton.addEventListener("click", (e) => {
    e.preventDefault();
    cartDrawer.open();
  });
});

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open");
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    // this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }

    document.addEventListener("click", (e) => {
      const button = e.target.closest("button");
      if (button && button.getAttribute("id")?.includes("ModalClose")) {
        this.hide.call(this);
      }
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class FsaModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("a");

    if (!button) return;
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("fsa-modal-opener", FsaModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.mql = window.matchMedia("(min-width: 750px)");

    this.bullets = this.querySelector(".slider-bullets");

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    if (this.bullets) {
      this.bullets.querySelectorAll(".slider-bullet").forEach((bullet) => {
        bullet.addEventListener("click", this.onBulletClick.bind(this));
      });
    }
  }

  isBetween(val, a, b, inclusive) {
    const min = Math.min.apply(Math, [a, b]);
    const max = Math.max.apply(Math, [a, b]);
    return inclusive ? val >= min && val <= max : val > min && val < max;
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.bullets) {
      this.bullets.querySelectorAll(".slider-bullet").forEach((bullet) => {
        bullet.classList.toggle("active", Number(bullet.dataset.index) === Number(this.currentPage));
      });
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  onBulletClick(event) {
    event.preventDefault();
    const index = event.currentTarget.dataset.index || 1;
    const slideScrollPosition = this.slider.scrollLeft + this.sliderItemOffset * (index - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener("click", this.linkToSlide.bind(this)));
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector(".announcement-bar-slider")) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia("(min-width: 750px)");
      this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

      [this.reducedMotion].forEach((mediaQuery) => {
        mediaQuery.addEventListener("change", () => {
          if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
    this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked &&
      this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector(".announcement-bar-slider").contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    if (!this.isBundler) {
      if (!VariantSelects.isInitialized) {
        sessionStorage.removeItem("selectedSize");
        sessionStorage.removeItem("selectedFit");
        sessionStorage.removeItem("selectedStyle");
        sessionStorage.removeItem("selectedLength");
        VariantSelects.isInitialized = true;
      }
    }
    this.addEventListener("change", this.onVariantChange);
    this.updateOptions();
    this.updateMasterId();
    this.updateKlaviyoBISForm();
    this.addAddToCartListener();
    this.initializeOverlayState();
  }

  updateCurrentFit(currentVariant) {
    const selectedFit = this.querySelector(".product-form__input.fit input:checked");
    if (selectedFit) {
      const value = selectedFit.value;
      const product = this.getProductData();
      const variants = product.variants;
      const variant = variants.find((variant) => variant.title.includes(value));

      return variant;
    } else {
      return currentVariant;
    }
  }

  initializeOverlayState() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const overlay = productForm.querySelector("[data-submit-wrapper]");
    if (!addButton || !overlay) return;

    // Check if this is a product with size/fit options
    const hasSizeOption = this.querySelector(".product-form__input.size") !== null;
    const hasFitOption = this.querySelector(".product-form__input.fit") !== null;
    const hasStyleOption = this.querySelector(".product-form__input.style") !== null;
    const hasLengthOption = this.querySelector(".product-form__input.length") !== null;

    if (hasSizeOption || hasFitOption || hasStyleOption) {
      const selectedSize = sessionStorage.getItem("selectedSize");
      const selectedFit = sessionStorage.getItem("selectedFit");
      const selectedStyle = sessionStorage.getItem("selectedStyle");
      const selectedLength = sessionStorage.getItem("selectedLength");

      // Show overlay if any required option is missing
      const hasRequiredOptions =
        (!hasSizeOption || selectedSize) &&
        (!hasFitOption || selectedFit) &&
        (!hasStyleOption || selectedStyle) &&
        (!hasLengthOption || selectedLength);

      if (!hasRequiredOptions) {
        overlay.style.display = "block";
        addButton.classList.add("button--disabled");
        addButton.setAttribute("disabled", "disabled");
      } else {
        overlay.style.display = "none";
        addButton.classList.remove("button--disabled");
        addButton.removeAttribute("disabled");
      }
    } else {
      // For products without special options, check if any option is selected
      const hasAnyOptionSelected = Array.from(this.querySelectorAll('.product-form__input input[type="radio"]')).some(
        (input) => input.checked,
      );
      const hasNoOptions = this.querySelectorAll(".product-form__input").length === 0;

      if (!hasAnyOptionSelected && !hasNoOptions) {
        overlay.style.display = "block";
        addButton.classList.add("button--disabled");
        addButton.setAttribute("disabled", "disabled");
      } else {
        overlay.style.display = "none";
        addButton.classList.remove("button--disabled");
        addButton.removeAttribute("disabled");
      }
    }
  }

  onVariantChange(event) {
    // Determine what triggered the change
    const isFitChange = event?.target?.closest(".product-form__input.fit") !== null;
    const isStyleChange = event?.target?.closest(".product-form__input.style") !== null;
    const isLengthChange = event?.target?.closest(".product-form__input.length") !== null;

    this.updateOptions();
    this.updateMasterId();
    /* Disable button while we refresh the variant, but show the correct label
       straight away so we don't flash "Sold Out" from the previous variant. */
    this.toggleAddButton(
      /* disable  */ true,
      /* text     */ window.variantStrings.addToCart,
      /* modify   */ false,
      true,
    );
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      // Only update media and URL if it's a size change
      if (!isFitChange && !isStyleChange && !isLengthChange) {
        this.updateMedia();
        this.updateURL();
      }

      this.updateVariantInput();
      // this.updateVariantFieldsets();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateKlaviyoBISForm();
      this.initializeOverlayState(); // Re-initialize overlay state after variant change
    }
  }

  updateOptions() {
    // Handle select elements for dropdown-based variant pickers
    const selects = this.querySelectorAll("select");
    this.options = Array.from(selects, (select) => select.value);
  }

  handleCheckOptions(product) {
    const selectedSize = sessionStorage.getItem("selectedSize");
    const selectedFit = sessionStorage.getItem("selectedFit");
    const selectedStyle = sessionStorage.getItem("selectedStyle");
    const selectedLength = sessionStorage.getItem("selectedLength");

    const sizeOptionIndex = product.options.findIndex((option) => option === "Size");
    const fitOptionIndex = product.options.findIndex((option) => option === "Fit");
    const styleOptionIndex = product.options.findIndex((option) => option === "Style");
    const lengthOptionIndex = product.options.findIndex((option) => option === "Length");

    if (!selectedSize && sizeOptionIndex >= 0) return false;
    if (!selectedFit && fitOptionIndex >= 0) return false;
    if (!selectedStyle && styleOptionIndex >= 0) return false;
    if (!selectedLength && lengthOptionIndex >= 0) return false;
    return true;
  }

  updateMasterId() {
    const selectedSize = sessionStorage.getItem("selectedSize");
    const selectedFit = sessionStorage.getItem("selectedFit");
    const selectedStyle = sessionStorage.getItem("selectedStyle");
    const selectedLength = sessionStorage.getItem("selectedLength");

    const product = this.getProductData();
    const variants = product.variants;
    const sizeOptionIndex = product.options.findIndex((option) => option === "Size");
    const fitOptionIndex = product.options.findIndex((option) => option === "Fit");
    const styleOptionIndex = product.options.findIndex((option) => option === "Style");
    const lengthOptionIndex = product.options.findIndex((option) => option === "Length");

    if (this.isBundler) {
      this.currentVariant = variants.find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    } else {
      if (!this.handleCheckOptions(product)) {
        this.currentVariant = variants.find((variant) => variant.available) || variants[0];
      } else if (selectedSize || selectedFit || selectedStyle || selectedLength) {
        this.currentVariant =
          variants.find((variant) => {
            return !variant.options
              .map((option, index) => {
                // Check for both size and fit matches
                return (
                  (index === sizeOptionIndex && (!selectedSize || option === selectedSize)) ||
                  (index === fitOptionIndex && (!selectedFit || option === selectedFit)) ||
                  (index === styleOptionIndex && (!selectedStyle || option === selectedStyle)) ||
                  (index === lengthOptionIndex && (!selectedLength || option === selectedLength)) ||
                  this.options[index] === option
                );
              })
              .includes(false);
          }) ||
          variants.find((variant) => variant.available) ||
          variants[0];
      } else {
        // For regular products without Size/Fit/Style/Length options, use the standard variant matching
        this.currentVariant =
          variants.find((variant) => {
            return !variant.options
              .map((option, index) => {
                return this.options[index] === option;
              })
              .includes(false);
          }) ||
          variants.find((variant) => variant.available) ||
          variants[0];
      }
    }
  }

  updateMedia() {
    const currentVariant = this.updateCurrentFit(this.currentVariant);
    if (!currentVariant) return;
    if (!currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    if (mediaGalleries) {
      mediaGalleries.forEach((mediaGallery) => {
        if (typeof mediaGallery.setActiveMedia === "function") {
          mediaGallery.setActiveMedia(`${this.dataset.section}-${currentVariant.featured_media.id}`, true);
        }
      });
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const variants = this.productData.variants;
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    const selectedFit = sessionStorage.getItem("selectedFit");
    const selectedStyle = sessionStorage.getItem("selectedStyle");
    const selectedLength = sessionStorage.getItem("selectedLength");
    const fitOptionIndex = this.productData.options.findIndex((opt) => opt === "Fit");
    const sizeOptionIndex = this.productData.options.findIndex((opt) => opt === "Size");
    const styleOptionIndex = this.productData.options.findIndex((opt) => opt === "Style");
    const lengthOptionIndex = this.productData.options.findIndex((opt) => opt === "Length");

    // Get all variants that match the selected fit/style/length (regardless of availability)
    let matchingVariants = variants;

    if (selectedFit && fitOptionIndex !== -1) {
      matchingVariants = matchingVariants.filter((variant) => variant.options[fitOptionIndex] === selectedFit);
    } else if (selectedStyle && styleOptionIndex !== -1) {
      matchingVariants = matchingVariants.filter((variant) => variant.options[styleOptionIndex] === selectedStyle);
    } else if (selectedLength && lengthOptionIndex !== -1) {
      matchingVariants = matchingVariants.filter((variant) => variant.options[lengthOptionIndex] === selectedLength);
    }

    // Get all sizes that exist for the selected fit/style/length combination (including OOS ones)
    const allMatchingSizes = new Set(matchingVariants.map((variant) => variant.options[sizeOptionIndex]));

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];

      if (option.classList.contains("size") && sizeOptionIndex !== -1) {
        optionInputs.forEach((input) => {
          const sizeValue = input.getAttribute("value");
          const sizeExists = allMatchingSizes.has(sizeValue);
          const parentItem = input.closest(".product-form__input-item");

          let matchingVariant;

          if (selectedFit && fitOptionIndex !== -1) {
            matchingVariant = variants.find(
              (variant) =>
                variant.options[sizeOptionIndex] === sizeValue && variant.options[fitOptionIndex] === selectedFit,
            );
          } else if (selectedStyle && styleOptionIndex !== -1) {
            matchingVariant = variants.find(
              (variant) =>
                variant.options[sizeOptionIndex] === sizeValue && variant.options[styleOptionIndex] === selectedStyle,
            );
          } else if (selectedLength && lengthOptionIndex !== -1) {
            matchingVariant = variants.find(
              (variant) =>
                variant.options[sizeOptionIndex] === sizeValue && variant.options[lengthOptionIndex] === selectedLength,
            );
          } else {
            matchingVariant = variants.find((variant) => variant.options[sizeOptionIndex] === sizeValue);
          }

          const isInStock = matchingVariant && matchingVariant.available;

          if (sizeExists) {
            input.classList.remove("hidden");
            if (parentItem) parentItem.style.display = "";

            if (!matchingVariant) {
              input.disabled = true;
              input.classList.add("disabled");
              // Uncheck if no matching variant exists
              if (input.checked) {
                input.checked = false;
              }
              input.innerText = window.variantStrings.unavailable_with_option.replace("[value]", sizeValue);
            } else {
              input.disabled = false;
              if (!isInStock) {
                input.classList.add("disabled");
              } else {
                input.classList.remove("disabled");
              }
              input.innerText = sizeValue;
            }
          } else {
            input.classList.add("hidden");
            if (parentItem) parentItem.style.display = "none";
            input.disabled = true;
            input.classList.add("disabled");
            input.innerText = window.variantStrings.unavailable_with_option.replace("[value]", sizeValue);
          }
        });
      } else {
        const validOptions = new Set(
          variants.filter((variant) => variant.available).map((variantOption) => variantOption[`option${index + 1}`]),
        );

        this.setInputAvailability(optionInputs, validOptions);
      }
    });

    if (this.currentVariant) {
      this.currentVariant.available = variants.find((v) => v.id === this.currentVariant.id)?.available || false;
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const value = input.getAttribute("value");
      const isAvailable = listOfAvailableOptions.has(value);

      if (isAvailable) {
        input.disabled = false;
        input.classList.remove("disabled");
        input.innerText = value;
      } else {
        input.disabled = true;
        input.classList.add("disabled");
        input.innerText = window.variantStrings.unavailable_with_option.replace("[value]", value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }${this.isBundler ? "&view=bundle-source" : ""}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(`[data-price="${this.dataset.section}"]`);
        const sources = html.querySelectorAll(
          `[data-price="${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}"]`,
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const colorSwatchSource = html.getElementById(`pdp-color-swatches-${this.dataset.section}`);
        const colorSwatchDestination = document.getElementById(`pdp-color-swatches-${this.dataset.section}`);

        if (sources && destinations) {
          destinations.forEach((destination, i) => {
            destination.innerHTML = sources[i].innerHTML;
          });
        }
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle("visibility-hidden", skuSource.classList.contains("visibility-hidden"));
        }

        if (colorSwatchSource && colorSwatchDestination) {
          colorSwatchDestination.replaceWith(colorSwatchSource);
        }

        const prices = document.querySelectorAll(`[data-price="${this.dataset.section}"]`);
        prices.forEach((price) => {
          price.classList.remove("visibility-hidden");
        });

        if (inventoryDestination)
          inventoryDestination.classList.toggle("visibility-hidden", inventorySource.innerText === "");

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        if (this.isBundler) {
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
            window.variantStrings.soldOut,
          );
        } else {
          // Get the actual variant from the product data to check availability
          const variant = this.productData.variants.find((v) => v.id === requestedVariantId);
          const isAvailable = variant ? variant.available : false;

          // Ensure the text is set to "Add to Cart" when enabling the button
          this.toggleAddButton(
            addButtonUpdated ? !isAvailable : true,
            isAvailable ? window.variantStrings.addToCart : window.variantStrings.soldOut,
          );
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, loading = false) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const addButtonPrice = productForm.querySelector(".product-form__submit--price");
    const overlay = productForm.querySelector("[data-submit-wrapper]");
    const loadingSpinner = productForm.querySelector(".loading-overlay__spinner");
    const submitButtonPriceOuter = productForm.querySelector(".product-form__submit--price-outer");
    if (!addButton) return;

    // Hide both error messages by default
    const sizeWarningLabel = this.querySelector("[data-size-warning]");
    const fitWarningLabel = this.querySelector("[data-fit-warning]");
    const styleWarningLabel = this.querySelector("[data-style-warning]");
    const lengthWarningLabel = this.querySelector("[data-length-warning]");
    // if (sizeWarningLabel) sizeWarningLabel.classList.add("hidden");
    // if (fitWarningLabel) fitWarningLabel.classList.add("hidden");
    // if (styleWarningLabel) styleWarningLabel.classList.add("hidden");
    // if (lengthWarningLabel) lengthWarningLabel.classList.add("hidden");

    if (loading) {
      addButton.classList.add("loading");
      loadingSpinner.classList.remove("hidden");
      addButton.setAttribute("disabled", "disabled");
    } else {
      addButton.classList.remove("loading");
      loadingSpinner.classList.add("hidden");
    }

    if (disable) {
      // Instead of disabling, add a class for styling
      addButton.classList.add("button--disabled");
      if (text) {
        addButtonText.textContent = text;
        addButton.setAttribute("disabled", "disabled");
      }
      // Show overlay when button is disabled
      if (overlay) overlay.style.display = "block";
    } else {
      if (this.isBundler) {
        addButton.classList.remove("button--disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
        if (addButtonPrice) addButtonPrice.textContent = Shopify.formatMoney(this.currentVariant.price);
        // Hide overlay for bundler
        if (overlay) overlay.style.display = "none";
      } else {
        // Check if this is a product with size/fit options
        const hasSizeOption = this.querySelector(".product-form__input.size") !== null;
        const hasFitOption = this.querySelector(".product-form__input.fit") !== null;
        const hasStyleOption = this.querySelector(".product-form__input.style") !== null;
        const hasLengthOption = this.querySelector(".product-form__input.length") !== null;

        if (hasSizeOption || hasFitOption || hasStyleOption || hasLengthOption) {
          const selectedSize = sessionStorage.getItem("selectedSize");
          const selectedFit = sessionStorage.getItem("selectedFit");
          const selectedStyle = sessionStorage.getItem("selectedStyle");
          const selectedLength = sessionStorage.getItem("selectedLength");

          // Show error messages only if add to cart was attempted and options aren't selected
          // if (addButton.hasAttribute("data-attempted-add")) {
          //   if (hasSizeOption && !selectedSize && sizeWarningLabel) {
          //     sizeWarningLabel.classList.remove("hidden");
          //   }
          //   if (hasFitOption && !selectedFit && fitWarningLabel) {
          //     fitWarningLabel.classList.remove("hidden");
          //   }
          //   if (hasStyleOption && !selectedStyle && styleWarningLabel) {
          //     styleWarningLabel.classList.remove("hidden");
          //   }

          //   if (hasLengthOption && !selectedLength && lengthWarningLabel) {
          //     lengthWarningLabel.classList.remove("hidden");
          //   }
          // }

          // Enable button if required options are selected
          const hasRequiredOptions =
            (!hasSizeOption || selectedSize) &&
            (!hasFitOption || selectedFit) &&
            (!hasStyleOption || selectedStyle) &&
            (!hasLengthOption || selectedLength);

          if (hasRequiredOptions) {
            addButton.classList.remove("button--disabled");
            addButton.removeAttribute("disabled");
            addButtonText.textContent = window.variantStrings.addToCart;
            if (addButtonPrice) addButtonPrice.textContent = Shopify.formatMoney(this.currentVariant.price);
            if (overlay) overlay.style.display = "none";
          } else {
            addButton.classList.add("button--disabled");
            addButton.setAttribute("disabled", "disabled");
            if (overlay) overlay.style.display = "block";
          }
        } else {
          // For products without special options, check if any option is selected
          const hasAnyOptionSelected = Array.from(
            this.querySelectorAll('.product-form__input input[type="radio"]'),
          ).some((input) => input.checked);
          const hasNoOptions = this.querySelectorAll(".product-form__input").length === 0;

          // Enable button if any option is selected or if there are no options
          if (hasAnyOptionSelected || hasNoOptions) {
            addButton.classList.remove("button--disabled");
            addButton.removeAttribute("disabled");
            addButtonText.textContent = window.variantStrings.addToCart;
            if (addButtonPrice) addButtonPrice.textContent = Shopify.formatMoney(this.currentVariant.price);
            if (overlay) overlay.style.display = "none";
          } else {
            addButton.classList.add("button--disabled");
            addButton.setAttribute("disabled", "disabled");
            if (overlay) overlay.style.display = "block";
          }
        }
      }
    }

    if (this.currentVariant && this.currentVariant.available) {
      submitButtonPriceOuter.classList.remove("hidden");
    } else {
      submitButtonPriceOuter.classList.add("hidden");
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const prices = document.querySelectorAll(`[data-price="${this.dataset.section}"]`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    prices.forEach((price) => {
      price.classList.add("visibility-hidden");
    });
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  updateVariantFieldsets() {
    /* Update option fieldsets */
    const fieldsets = this.querySelectorAll("fieldset");

    fieldsets.forEach((fieldset, i) => {
      const optionName = `option${i + 1}`;

      fieldset.querySelector(".form__current-variant").innerHTML = this.currentVariant[optionName];
    });
    /* Update option fieldsets */
  }

  getProductData() {
    this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.productData;
  }

  updateKlaviyoBISForm() {
    const klaviyoBISContainer = document.querySelector("klaviyo-bis-form");
    if (!klaviyoBISContainer) return;

    // Reset Klaviyo form visibility
    klaviyoBISContainer.querySelector(".klaviyo-bis-trigger")?.classList.remove("hidden");
    klaviyoBISContainer.querySelector("form")?.classList.add("hidden");
    klaviyoBISContainer.querySelector(".klaviyo-bis-form-inner")?.classList.remove("hidden");
    klaviyoBISContainer.querySelector(".klaviyo-bis-success")?.classList.add("hidden");

    // Input variant data
    const variantIdInput = klaviyoBISContainer.querySelector('input[name="variantId"]');
    if (variantIdInput && this.currentVariant) {
      variantIdInput.value = this.currentVariant.id;
    }

    // Ensure we have the latest availability status
    if (this.currentVariant) {
      const variant = this.productData.variants.find((v) => v.id === this.currentVariant.id);
      if (variant) {
        this.currentVariant.available = variant.available;
      }
    }

    if (this.isBundler) {
      klaviyoBISContainer.classList.toggle("hidden", this.currentVariant?.available);
    } else {
      // Select all target elements with the [data-klaviyo-hide] attribute
      const targetElements = document.querySelectorAll("[data-klaviyo-hide]");

      // Toggle Klaviyo form visibility based on variant availability
      const isFormVisible = !this.currentVariant?.available;
      klaviyoBISContainer.classList.toggle("hidden", !isFormVisible);

      // Toggle visibility of all target elements based on Klaviyo form visibility
      targetElements.forEach((element) => {
        element.classList.toggle("hidden", isFormVisible);
      });

      // Ensure the notify me button is properly enabled/disabled
      const notifyMeButton = klaviyoBISContainer.querySelector(".klaviyo-bis-trigger.button");
      if (notifyMeButton) {
        if (isFormVisible) {
          notifyMeButton.removeAttribute("disabled");
        } else {
          notifyMeButton.setAttribute("disabled", "disabled");
        }
      }
    }
  }

  addAddToCartListener() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const overlay = productForm.querySelector("[data-submit-wrapper]");
    const addButton = productForm.querySelector('[name="add"]');

    if (overlay && addButton) {
      // Remove any existing click listeners
      overlay.removeEventListener("click", this.handleAddToCartClick);

      // Add click listener to the overlay
      overlay.addEventListener("click", (event) => {
        this.handleAddToCartClick(event);
      });
    }
  }

  handleAddToCartClick(event) {
    const selectedSize = sessionStorage.getItem("selectedSize");
    const selectedFit = sessionStorage.getItem("selectedFit");
    const selectedStyle = sessionStorage.getItem("selectedStyle");
    const selectedLength = sessionStorage.getItem("selectedLength");
    const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
    const overlay = document
      .getElementById(`product-form-${this.dataset.section}`)
      .querySelector("[data-submit-wrapper]");

    // Check if this is a product with size/fit/style options
    const hasSizeOption = this.querySelector(".product-form__input.size") !== null;
    const hasFitOption = this.querySelector(".product-form__input.fit") !== null;
    const hasStyleOption = this.querySelector(".product-form__input.style") !== null;
    const hasLengthOption = this.querySelector(".product-form__input.length") !== null;

    // If it's a product with special options, check if all required options are selected
    if (hasSizeOption || hasFitOption || hasStyleOption) {
      const hasRequiredOptions =
        (!hasSizeOption || selectedSize) &&
        (!hasFitOption || selectedFit) &&
        (!hasStyleOption || selectedStyle) &&
        (!hasLengthOption || selectedLength);

      // If all required options are selected and button is not disabled, let the form submit
      if (hasRequiredOptions && !addButton.disabled) {
        if (overlay) overlay.style.display = "none";
        return;
      }
    } else {
      // For products without special options, check if any option is selected
      const hasAnyOptionSelected = Array.from(this.querySelectorAll('.product-form__input input[type="radio"]')).some(
        (input) => input.checked,
      );
      const hasNoOptions = this.querySelectorAll(".product-form__input").length === 0;

      // If any option is selected or there are no options, let the form submit
      if ((hasAnyOptionSelected || hasNoOptions) && !addButton.disabled) {
        if (overlay) overlay.style.display = "none";
        return;
      }
    }

    // If we get here, prevent form submission and show error messages
    event.preventDefault();
    event.stopPropagation();

    // Show error messages for missing selections
    const sizeLabel = this.querySelector("[data-size-label]");
    const fitLabel = this.querySelector("[data-fit-label]");
    const styleLabel = this.querySelector("[data-style-label]");
    const lengthLabel = this.querySelector("[data-length-label]");
    const sizeWarningLabel = this.querySelector("[data-size-warning]");
    const fitWarningLabel = this.querySelector("[data-fit-warning]");
    const styleWarningLabel = this.querySelector("[data-style-warning]");
    const lengthWarningLabel = this.querySelector("[data-length-warning]");

    if (hasSizeOption && !selectedSize && sizeLabel && sizeWarningLabel) {
      sizeLabel.classList.add("hidden");
      sizeWarningLabel.classList.remove("hidden");
    }

    if (hasFitOption && !selectedFit && fitLabel && fitWarningLabel) {
      fitLabel.classList.add("hidden");
      fitWarningLabel.classList.remove("hidden");
    }

    if (hasStyleOption && !selectedStyle && styleLabel && styleWarningLabel) {
      styleLabel.classList.add("hidden");
      styleWarningLabel.classList.remove("hidden");
    }

    if (hasLengthOption && !selectedLength && lengthLabel && lengthWarningLabel) {
      lengthLabel.classList.add("hidden");
      lengthWarningLabel.classList.remove("hidden");
    }

    // Mark the button as attempted to show error messages
    if (addButton) {
      addButton.setAttribute("data-attempted-add", "true");
    }

    // Ensure overlay is visible when we're preventing the click
    if (overlay) overlay.style.display = "block";
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  static isInitialized = false;

  constructor() {
    super();
    this.checkAndSetDefaultOption();
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Single event listener for all radio changes
    this.addEventListener("change", (event) => {
      const radio = event.target.closest('input[type="radio"]');
      if (!radio) return;

      if (radio.closest(".product-form__input.size")) {
        this.handleSizeChange(radio);
      } else if (radio.closest(".product-form__input.fit")) {
        this.handleFitChange(radio);
      } else if (radio.closest(".product-form__input.style")) {
        this.handleStyleChange(radio);
      } else if (radio.closest(".product-form__input.length")) {
        this.handleLengthChange(radio);
      }
    });
  }

  handleSizeChange(radio) {
    if (radio.checked) {
      sessionStorage.setItem("selectedSize", radio.value);
      const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
      if (addButton) {
        addButton.removeAttribute("data-attempted-add");
      }

      // Only handle size-related elements
      const sizeWarningLabel = this.querySelector("[data-size-warning]");
      const sizeLabel = this.querySelector("[data-size-label]");
      if (sizeWarningLabel) {
        sizeWarningLabel.classList.add("hidden");
      }
      if (sizeLabel) {
        sizeLabel.classList.remove("hidden");
        const sizeCurrentVariant = sizeLabel.querySelector(".form__current-variant");
        if (sizeCurrentVariant) {
          sizeCurrentVariant.classList.remove("hidden");

          sizeCurrentVariant.textContent = radio.value;
        }
      }

      // Update the variant ID in the form
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput && this.currentVariant) {
          variantInput.value = this.currentVariant.id;
          variantInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

      this.updateSizeLabel("size");

      // Trigger variant change to ensure everything is updated
      this.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  handleLengthChange(radio) {
    if (radio.checked) {
      // Clear size selection
      sessionStorage.removeItem("selectedSize");

      // Update length selection
      sessionStorage.setItem("selectedLength", radio.value);

      const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
      if (addButton) {
        addButton.removeAttribute("data-attempted-add");
      }

      // Handle length-related elements
      const lengthWarningLabel = this.querySelector("[data-length-warning]");
      const lengthLabel = this.querySelector("[data-length-label]");
      if (lengthWarningLabel) {
        lengthWarningLabel.classList.add("hidden");
      }
      if (lengthLabel) {
        lengthLabel.classList.remove("hidden");
        const lengthCurrentVariant = lengthLabel.querySelector(".form__current-variant");
        if (lengthCurrentVariant) {
          lengthCurrentVariant.classList.remove("hidden");

          lengthCurrentVariant.textContent = radio.value;
        }
      }

      // Clear only the current variant part of size label and uncheck size radio

      const sizeLabel = this.querySelector("[data-size-label]");
      if (sizeLabel) {
        const sizeCurrentVariant = sizeLabel.querySelector(".form__current-variant");
        if (sizeCurrentVariant != null) {
          // sizeCurrentVariant.classList.add("hidden");
          sizeCurrentVariant.textContent = "";
        }
      }

      // Uncheck any selected size radio input
      const sizeRadios = this.querySelectorAll('.product-form__input.size input[type="radio"]');
      sizeRadios.forEach((sizeRadio) => {
        if (sizeRadio.checked) {
          sizeRadio.checked = false;
        }
      });

      // Update size label
      this.updateSizeLabel("length");

      // Trigger variant change which will handle all the necessary updates
      this.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  handleClick(e) {
    // Get the new image sources from the clicked swatch
    const button = e.target.closest("button");
    const newPrimarySrc = button.dataset.imgSrc;
    const newSecondarySrc = button.dataset.secondaryImgSrc;
    const newPrimarySrcset = button.dataset.imgSrcset;
    const newSecondarySrcset = button.dataset.secondaryImgSrcset;
    const newUrl = button.dataset.url;
    const linkElementId = button.dataset.linkElementId;

    // Find the product card wrapper and media container
    const productCardWrapper = this.closest(".product-card-wrapper");
    const mediaContainer = productCardWrapper.querySelector(".card__media .media");

    if (mediaContainer) {
      // Update the primary image
      const primaryImg = mediaContainer.querySelector("img:first-child");
      if (primaryImg && newPrimarySrc) {
        primaryImg.src = newPrimarySrc;
        primaryImg.srcset = newPrimarySrcset;
      }

      // Handle the secondary image for hover effect
      let secondaryImg = mediaContainer.querySelector("img:nth-child(2)");
      if (newSecondarySrc && newSecondarySrc !== newPrimarySrc) {
        // Create or update secondary image
        if (!secondaryImg) {
          secondaryImg = document.createElement("img");
          secondaryImg.src = newSecondarySrc;
          secondaryImg.srcset = newSecondarySrcset;
          secondaryImg.sizes = primaryImg.sizes;
          secondaryImg.alt = "";
          secondaryImg.className = "motion-reduce";
          secondaryImg.width = primaryImg.width;
          secondaryImg.height = primaryImg.height;
          mediaContainer.appendChild(secondaryImg);
        } else {
          // Update existing secondary image
          secondaryImg.src = newSecondarySrc;
          secondaryImg.srcset = newSecondarySrcset;
        }
      } else if (secondaryImg && newSecondarySrc === newPrimarySrc) {
        // Remove secondary image if it's the same as primary
        secondaryImg.remove();
      }
    }

    // Update the product link URL
    if (newUrl && linkElementId) {
      const linkElement = document.getElementById(linkElementId);
      if (linkElement) {
        linkElement.href = newUrl;
      }
    }

    // Update swatch status (keeping existing logic)
    let parent = e.target.closest(".card-swatch-switcher");
    let swatches = parent.querySelectorAll("button");
    let prev_swatch_status = [];
    swatches.forEach((swatch) => {
      let linkID = swatch.getAttribute("data-linked-product-id");
      let selectedSizesInStock = swatch.getAttribute("data-selected-sizes-instock");
      const swatchObject = {
        linkID,
        selectedSizesInStock,
      };
      prev_swatch_status.push(swatchObject);
    });
  }

  handleFitChange(radio) {
    if (radio.checked) {
      // Clear any previously selected fit radios first
      const allFitRadios = this.querySelectorAll('.product-form__input.fit input[type="radio"]');
      allFitRadios.forEach((fitRadio) => {
        if (fitRadio !== radio && fitRadio.checked) {
          fitRadio.checked = false;
        }
      });

      // Clear size selection
      sessionStorage.removeItem("selectedSize");

      // Update fit selection
      sessionStorage.setItem("selectedFit", radio.value);

      const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
      if (addButton) {
        addButton.removeAttribute("data-attempted-add");
      }

      // Handle fit-related elements
      const fitWarningLabel = this.querySelector("[data-fit-warning]");
      const fitLabel = this.querySelector("[data-fit-label]");
      if (fitWarningLabel) {
        fitWarningLabel.classList.add("hidden");
      }
      if (fitLabel) {
        fitLabel.classList.remove("hidden");
        const fitCurrentVariant = fitLabel.querySelector(".form__current-variant");
        if (fitCurrentVariant) {
          fitCurrentVariant.classList.remove("hidden");

          fitCurrentVariant.textContent = radio.value;
        }
      }

      // Clear only the current variant part of size label and uncheck size radio
      const sizeLabel = this.querySelector("[data-size-label]");
      if (sizeLabel) {
        const sizeCurrentVariant = sizeLabel.querySelector(".form__current-variant");
        if (sizeCurrentVariant) {
          sizeCurrentVariant.classList.add("hidden");
          sizeCurrentVariant.textContent = "";
        }
      }

      // Uncheck any selected size radio input
      const sizeRadios = this.querySelectorAll('.product-form__input.size input[type="radio"]');
      sizeRadios.forEach((sizeRadio) => {
        if (sizeRadio.checked) {
          sizeRadio.checked = false;
        }
      });

      // Update size label
      this.updateSizeLabel("fit");

      // Trigger variant change which will handle all the necessary updates
      this.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  handleStyleChange(radio) {
    if (radio.checked) {
      // Clear size selection
      sessionStorage.removeItem("selectedSize");

      // Update style selection
      sessionStorage.setItem("selectedStyle", radio.value);

      const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
      if (addButton) {
        addButton.removeAttribute("data-attempted-add");
      }

      // Handle style-related elements
      const styleWarningLabel = this.querySelector("[data-style-warning]");
      const styleLabel = this.querySelector("[data-style-label]");
      if (styleWarningLabel) {
        styleWarningLabel.classList.add("hidden");
      }
      if (styleLabel) {
        styleLabel.classList.remove("hidden");
        const styleCurrentVariant = styleLabel.querySelector(".form__current-variant");
        if (styleCurrentVariant) {
          styleCurrentVariant.classList.remove("hidden");

          styleCurrentVariant.textContent = radio.value;
        }
      }

      // Clear only the current variant part of size label and uncheck size radio
      const sizeLabel = this.querySelector("[data-size-label]");
      if (sizeLabel) {
        const sizeCurrentVariant = sizeLabel.querySelector(".form__current-variant");
        if (sizeCurrentVariant) {
          sizeCurrentVariant.classList.add("hidden");
          sizeCurrentVariant.textContent = "";
        }
      }

      // Uncheck any selected size radio input
      const sizeRadios = this.querySelectorAll('.product-form__input.size input[type="radio"]');
      sizeRadios.forEach((sizeRadio) => {
        if (sizeRadio.checked) {
          sizeRadio.checked = false;
        }
      });

      // Update size label
      this.updateSizeLabel("style");

      // Trigger variant change which will handle all the necessary updates
      this.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  updateSizeLabel(updatingOption = null) {
    const selectedSize = sessionStorage.getItem("selectedSize");
    const selectedFit = sessionStorage.getItem("selectedFit");
    const selectedStyle = sessionStorage.getItem("selectedStyle");
    const selectedLength = sessionStorage.getItem("selectedLength");

    // Only update Size label if we're explicitly updating size
    if (updatingOption === "size") {
      const sizeWarningLabel = this.querySelector("[data-size-warning]");
      const sizeLabel = this.querySelector("[data-size-label]");
      if (sizeLabel) {
        const sizeCurrentVariant = sizeLabel.querySelector(".form__current-variant");
        if (selectedSize) {
          sizeCurrentVariant.classList.remove("hidden");

          sizeCurrentVariant.textContent = selectedSize;
          if (sizeWarningLabel) {
            sizeWarningLabel.classList.add("hidden");
          }
        } else {
          sizeCurrentVariant.classList.add("hidden");
          sizeCurrentVariant.textContent = "";
        }
      }
    }

    // Only update Fit label if we're explicitly updating fit
    if (updatingOption === "fit") {
      const fitWarningLabel = this.querySelector("[data-fit-warning]");
      const fitLabel = this.querySelector("[data-fit-label]");
      if (fitLabel) {
        const fitCurrentVariant = fitLabel.querySelector(".form__current-variant");
        if (selectedFit) {
          fitCurrentVariant.classList.remove("hidden");
          fitCurrentVariant.textContent = selectedFit;
          if (fitWarningLabel) {
            fitWarningLabel.classList.add("hidden");
          }
        } else {
          fitCurrentVariant.classList.add("hidden");
          fitCurrentVariant.textContent = "";
        }
      }
    }

    // Only update Style label if we're explicitly updating style
    if (updatingOption === "style") {
      const styleWarningLabel = this.querySelector("[data-style-warning]");
      const styleLabel = this.querySelector("[data-style-label]");
      if (styleLabel) {
        const styleCurrentVariant = styleLabel.querySelector(".form__current-variant");
        if (selectedStyle) {
          styleCurrentVariant.classList.remove("hidden");
          styleCurrentVariant.textContent = selectedStyle;
          if (styleWarningLabel) {
            styleWarningLabel.classList.add("hidden");
          }
        } else {
          styleCurrentVariant.classList.add("hidden");
          styleCurrentVariant.textContent = "";
        }
      }
    }

    // Only update Length label if we're explicitly updating length
    if (updatingOption === "length") {
      const lengthWarningLabel = this.querySelector("[data-length-warning]");
      const lengthLabel = this.querySelector("[data-length-label]");
      if (lengthLabel) {
        const lengthCurrentVariant = lengthLabel.querySelector(".form__current-variant");
        if (selectedLength) {
          lengthCurrentVariant.classList.remove("hidden");
          lengthCurrentVariant.textContent = selectedLength;
          if (lengthWarningLabel) {
            lengthWarningLabel.classList.add("hidden");
          }
        } else {
          lengthCurrentVariant.classList.add("hidden");
          lengthCurrentVariant.textContent = "";
        }
      }
    }

    // If updating size, only hide fit/style/length labels if they're not selected
    if (updatingOption === "size") {
      const fitLabel = this.querySelector("[data-fit-label]");
      const styleLabel = this.querySelector("[data-style-label]");
      const lengthLabel = this.querySelector("[data-length-label]");

      if (fitLabel) {
        const fitCurrentVariant = fitLabel.querySelector(".form__current-variant");
        if (selectedFit) {
          fitCurrentVariant.classList.remove("hidden");
          fitCurrentVariant.textContent = selectedFit;
        } else {
          fitCurrentVariant.classList.remove("hidden");
          fitCurrentVariant.textContent = "";
        }
      }

      if (styleLabel) {
        const styleCurrentVariant = styleLabel.querySelector(".form__current-variant");
        if (selectedStyle) {
          styleCurrentVariant.classList.remove("hidden");
          styleCurrentVariant.textContent = selectedStyle;
        } else {
          styleCurrentVariant.classList.remove("hidden");
          styleCurrentVariant.textContent = "";
        }
      }

      if (lengthLabel) {
        const lengthCurrentVariant = lengthLabel.querySelector(".form__current-variant");
        if (selectedLength) {
          lengthCurrentVariant.classList.remove("hidden");
          lengthCurrentVariant.textContent = selectedLength;
        } else {
          lengthCurrentVariant.classList.remove("hidden");
          lengthCurrentVariant.textContent = "";
        }
      }
    }

    // If no updatingOption is specified, ensure all labels reflect their current state
    if (!updatingOption) {
      const sizeLabel = this.querySelector("[data-size-label]");
      const fitLabel = this.querySelector("[data-fit-label]");
      const styleLabel = this.querySelector("[data-style-label]");
      const lengthLabel = this.querySelector("[data-length-label]");

      if (sizeLabel) {
        const sizeCurrentVariant = sizeLabel.querySelector(".form__current-variant");
        if (selectedSize) {
          sizeCurrentVariant.classList.remove("hidden");

          sizeCurrentVariant.textContent = selectedSize;
        } else {
          sizeCurrentVariant.classList.add("hidden");
          sizeCurrentVariant.textContent = "";
        }
      }

      if (fitLabel) {
        const fitCurrentVariant = fitLabel.querySelector(".form__current-variant");
        if (selectedFit) {
          fitCurrentVariant.classList.remove("hidden");
          fitCurrentVariant.textContent = selectedFit;
        } else {
          fitCurrentVariant.classList.remove("hidden");
          fitCurrentVariant.textContent = "";
        }
      }

      if (styleLabel) {
        const styleCurrentVariant = styleLabel.querySelector(".form__current-variant");
        if (selectedStyle) {
          styleCurrentVariant.classList.remove("hidden");
          styleCurrentVariant.textContent = selectedStyle;
        } else {
          styleCurrentVariant.classList.remove("hidden");
          styleCurrentVariant.textContent = "";
        }
      }

      if (lengthLabel) {
        const lengthCurrentVariant = lengthLabel.querySelector(".form__current-variant");
        if (selectedLength) {
          lengthCurrentVariant.classList.remove("hidden");
          lengthCurrentVariant.textContent = selectedLength;
        } else {
          lengthCurrentVariant.classList.remove("hidden");
          lengthCurrentVariant.textContent = "";
        }
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    if (this.isBundler) {
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
      });
    } else {
      // Handle radio button inputs for regular products
      this.options = Array.from(fieldsets, (fieldset) => {
        const checkedRadio = Array.from(fieldset.querySelectorAll("input[type='radio']")).find(
          (radio) => radio.checked,
        );
        return checkedRadio ? checkedRadio.value : null;
      });
    }
  }

  checkAndSetDefaultOption() {
    // Use URLSearchParams to parse query parameters
    const fitRadios = this.querySelectorAll('.product-form__input.fit input[type="radio"]');
    const styleRadios = this.querySelectorAll('.product-form__input.style input[type="radio"]');
    const lengthRadios = this.querySelectorAll('.product-form__input.length input[type="radio"]');

    fitRadios.forEach((radio) => {
      if (radio.checked) {
        radio.checked = false;
      }
    });

    styleRadios.forEach((radio) => {
      if (radio.checked) {
        radio.checked = false;
      }
    });

    lengthRadios.forEach((radio) => {
      if (radio.checked) {
        radio.checked = false;
      }
    });

    // Update options to reflect the new default selection
    this.updateOptions();
  }
}

customElements.define("variant-radios", VariantRadios);

/**
 * ---------------------------------------------------------------------------
 * Kindred Bravely theme hardening (default-variant support)
 * ---------------------------------------------------------------------------
 *
 * Shopify products can have a single "Default Title" variant.
 * Dawn typically hides the variant picker for those products.
 *
 * This theme historically relied on variant-picker initialization/change events
 * to drive other functionality (Klaviyo BIS enablement, PDP color-swatch URL sync).
 * For default-variant products there may be no picker, so we add defensive fallbacks
 * that:
 *  - derive a variant id from the DOM when needed
 *  - keep URL updates safe (never write ?variant=null)
 *  - make the Klaviyo BIS component self-initialize even without a picker
 *
 * Debugging:
 *  - Set localStorage.kb_debug = "1" OR add ?kb_debug=1 to enable verbose logs.
 */
const KB_DEBUG_ENABLED =
  window?.localStorage?.getItem("kb_debug") === "1" || new URLSearchParams(window.location.search).has("kb_debug");

function kbDebug(...args) {
  if (!KB_DEBUG_ENABLED) return;
  console.debug("[KB theme]", ...args);
}

function kbWarn(...args) {
  console.warn("[KB theme]", ...args);
}

function kbError(...args) {
  console.error("[KB theme]", ...args);
}

function kbNormalizeVariantId(raw) {
  if (raw === null || raw === undefined) return null;

  // IMPORTANT: Shopify variant IDs can be large. Do not coerce via Number(), which can
  // introduce precision loss above Number.MAX_SAFE_INTEGER.
  const s = String(raw).trim();
  if (!s) return null;

  // Accept only digit strings.
  if (!/^\d+$/.test(s)) return null;

  // Disallow all-zero values.
  if (/^0+$/.test(s)) return null;

  // Normalize leading zeros defensively.
  return s.replace(/^0+/, "");
}

/**
 * Best-effort variant id discovery within a specific DOM scope.
 *
 * Prefer the add-to-cart form input[name="id"], which exists even for default-variant
 * products, but keep fallbacks for Dawn-derived markup.
 */
function kbGetVariantIdFromScope(scope) {
  if (!scope) return null;

  const candidates = [
    // Primary: the add-to-cart form variant id input.
    scope.querySelector('form[id^="product-form-"] input[name="id"]'),
    // Fallbacks seen in Dawn-derived themes.
    scope.querySelector('input.product-variant-id'),
    scope.querySelector('input[name="id"]'),
  ].filter(Boolean);

  for (const el of candidates) {
    const normalized = kbNormalizeVariantId(el.value || el.getAttribute("value"));
    if (normalized) return normalized;
  }
  return null;
}

/**
 * Best-effort variant id discovery.
 *
 * We prefer reading from the product form input[name="id"], which exists even for
 * default-variant products, and also survives section swaps.
 */
function kbGetVariantIdFromDom(sectionId = null) {
  const scope = sectionId ? document.getElementById(`MainProduct-${sectionId}`) : document;
  return kbGetVariantIdFromScope(scope);
}

function kbGetSectionIdFromElement(el) {
  if (!el) return null;
  const main = el.closest('[id^="MainProduct-"]');
  if (main?.id) return main.id.replace("MainProduct-", "");
  return null;
}

class PDPColorSwatches extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll("button");
    this.buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleClick(e);
      });
    });

    this.cache = {};
    this.isBundler = this.dataset.isBundler;
    this.bundler = document.querySelector("bundle-builder");

    this.fetchSectionDataForAlternateColors(
      [this.dataset.sectionId, ...(this.isBundler ? ["bundle-source-reviews"] : [])],
      this.isBundler,
    );
  }

  updateIGGallery(originalParsedUrl, galleryParent) {
    let urlToFetch = originalParsedUrl.toString();
    fetch(urlToFetch)
      .then((response) => response.text())
      .then((responseText) => {
        let fetchedHTML = new DOMParser().parseFromString(responseText, "text/html");
        let igGallery = fetchedHTML.querySelector(".covet-pics-shopify-block");
        if (igGallery) {
          galleryParent.innerHTML = "";
          galleryParent.appendChild(igGallery);
        }
      });
  }

  handleClick(e) {
    const isBundler = !!this.isBundler && !!this.bundler;
    const button = e.target.closest("button");
    if (button.dataset.isSelected === "true") return;

    // =========================================================
    // EASIFY INTERCEPTOR
    // =========================================================
    const targetRequiresReload = button.dataset.requiresReload === "true";

    if (targetRequiresReload) {
      // Force a hard redirect to the new product
      console.log("EASIFY: Force a hard redirect to the new product")
      const targetUrl = button.dataset.url;
      const variantId = button.dataset.variantId;
      
      const destinationUrl = new URL(targetUrl, window.location.origin);
      if (variantId) {
        destinationUrl.searchParams.set('variant', variantId);
      }
      
      window.location.href = destinationUrl.toString();
      return; // Stop the AJAX swap completely
    }
    // =========================================================

    const dropAHintButton = document.getElementById("dropahint_wrapper")?.firstChild;

    const sectionId = button.dataset.sectionId;

    // parsedUrl makes changes to specifically grab only the main product section, while the originalParsedUrl will give us the full url
    // used for a separate fetch request updating the IG gallery, or anything else if needed in the future.

    const parsedUrl = new URL(button.dataset.url, window.location.origin);
    const originalParsedUrl = new URL(button.dataset.url, window.location.origin);
    const variantId =
      kbNormalizeVariantId(parsedUrl.searchParams.get("variant")) || kbNormalizeVariantId(button.dataset.variantId);

    kbDebug("PDP color swatch click", {
      handle: button.dataset.handle,
      sectionId,
      url: button.dataset.url,
      variantId,
      isBundler,
    });

    parsedUrl.searchParams.set("sections", [sectionId, ...(isBundler ? ["bundle-source-reviews"] : [])].join(","));
    if (isBundler) {
      parsedUrl.searchParams.set("view", "bundle-source");
    }

    const response = this.cache[parsedUrl.toString()];
    if (response) {
      if (isBundler) {
        this.bundler.updateProductInfo(response);
      } else {
        this.renderNewSection(response[sectionId], sectionId, variantId, parsedUrl, dropAHintButton);
        // check for IG gallery and update if it exists
        const igGallery = document.querySelector(".covet-pics-shopify-block");
        const galleryParent = igGallery ? igGallery.parentElement : null;
        if (igGallery && galleryParent) {
          this.updateIGGallery(originalParsedUrl, galleryParent);
        }
      }
    } else {
      fetch(parsedUrl)
        .then((response) => response.json())
        .then((responseJson) => {
          if (isBundler) {
            this.bundler.updateProductInfo(responseJson);
          } else {
            this.renderNewSection(responseJson[sectionId], sectionId, variantId, parsedUrl, dropAHintButton);
          }
        })
        .catch(() => {
          parsedUrl.searchParams.delete("sections");
          window.location = parsedUrl.toString();
        });
    }
  }

  renderNewSection(html, sectionId, variantId, parsedUrl, dropAHintButton) {
    // --- Preserve previous selections before DOM replacement ---
    const previousSelectedSize = sessionStorage.getItem("selectedSize");
    const previousSelectedFit = sessionStorage.getItem("selectedFit");
    const previousSelectedStyle = sessionStorage.getItem("selectedStyle");
    const previousSelectedLength = sessionStorage.getItem("selectedLength");

    const destination = document.getElementById(`MainProduct-${sectionId}`);
    const source = new DOMParser().parseFromString(html, "text/html").getElementById(`MainProduct-${sectionId}`);

    const modalDestination = document.getElementById(`ProductModal-${sectionId}`);
    const modalSource = new DOMParser().parseFromString(html, "text/html").getElementById(`ProductModal-${sectionId}`);

    if (source && destination) {
      destination.innerHTML = source.innerHTML;
    }

    if (modalSource && modalDestination) {
      modalDestination.innerHTML = modalSource.innerHTML;
    }

    let productBanner = document.querySelector(".product-banner");
    if (productBanner) {
      document.documentElement.style.setProperty("--banner-height", productBanner.offsetHeight + "px");
    } else {
      document.documentElement.style.setProperty("--banner-height", 0 + "px");
    }

    if (dropAHintButton && document.getElementById("dropahint_wrapper")) {
      document.getElementById("dropahint_wrapper").appendChild(dropAHintButton);
    }

    // --- Reset fit and size selections (will restore if valid below) ---
    sessionStorage.removeItem("selectedSize");
    sessionStorage.removeItem("selectedFit");
    sessionStorage.removeItem("selectedStyle");
    sessionStorage.removeItem("selectedLength");

    // Clear size label
    const sizeLabel = document.querySelector("[data-size-label]");
    if (sizeLabel) {
      const sizeCurrentVariant = sizeLabel.querySelector(".form__current-variant");
      if (sizeCurrentVariant) {
        sizeCurrentVariant.classList.add("hidden");
        sizeCurrentVariant.textContent = "";
      }
    }

    // Clear fit label
    const fitLabel = document.querySelector("[data-fit-label]");
    if (fitLabel) {
      const fitCurrentVariant = fitLabel.querySelector(".form__current-variant");
      if (fitCurrentVariant) {
        fitCurrentVariant.classList.add("hidden");
        fitCurrentVariant.textContent = "";
      }
    }

    // Clear style label
    const styleLabel = document.querySelector("[data-style-label]");
    if (styleLabel) {
      const styleCurrentVariant = styleLabel.querySelector(".form__current-variant");
      if (styleCurrentVariant) {
        styleCurrentVariant.classList.add("hidden");
        styleCurrentVariant.textContent = "";
      }
    }

    // Clear length label
    const lengthLabel = document.querySelector("[data-length-label]");
    if (lengthLabel) {
      const lengthCurrentVariant = lengthLabel.querySelector(".form__current-variant");
      if (lengthCurrentVariant) {
        lengthCurrentVariant.classList.add("hidden");
        lengthCurrentVariant.textContent = "";
      }
    }

    // Uncheck any selected size radio inputs
    const sizeRadios = document.querySelectorAll('.product-form__input.size input[type="radio"]');
    sizeRadios.forEach((sizeRadio) => {
      if (sizeRadio.checked) {
        sizeRadio.checked = false;
      }
    });

    // Uncheck any selected fit radio inputs
    const fitRadios = document.querySelectorAll('.product-form__input.fit input[type="radio"]');
    fitRadios.forEach((fitRadio) => {
      if (fitRadio.checked) {
        fitRadio.checked = false;
      }
    });

    // Uncheck any selected style radio inputs
    const styleRadios = document.querySelectorAll('.product-form__input.style input[type="radio"]');
    styleRadios.forEach((styleRadio) => {
      if (styleRadio.checked) {
        styleRadio.checked = false;
      }
    });

    const lengthRadios = document.querySelectorAll('.product-form__input.length input[type="radio"]');
    lengthRadios.forEach((lengthRadio) => {
      if (lengthRadio.checked) {
        lengthRadio.checked = false;
      }
    });

    // Show overlay and disable button after color change
    const productForm = document.getElementById(`product-form-${sectionId}`);
    if (productForm) {
      const addButton = productForm.querySelector('[name="add"]');
      const overlay = productForm.querySelector("[data-submit-wrapper]");
      if (addButton && overlay) {
        // Check if this product has size/fit/style options
        const hasSizeOption = document.querySelector(".product-form__input.size") !== null;
        const hasFitOption = document.querySelector(".product-form__input.fit") !== null;
        const hasStyleOption = document.querySelector(".product-form__input.style") !== null;
        const hasLengthOption = document.querySelector(".product-form__input.length") !== null;
        if (hasSizeOption || hasFitOption || hasStyleOption || hasLengthOption) {
          overlay.style.display = "block";
          addButton.classList.add("button--disabled");
          addButton.setAttribute("disabled", "disabled");
        }
      }
    }

    // --- Restore previous selections if valid for new product ---
    // Wait for DOM update to complete
    setTimeout(() => {
      // Find the variant component (variant-radios or variant-selects)
      const variantComponent = document.querySelector("variant-radios, variant-selects");
      if (!variantComponent) {
        // Default-variant products may not render a picker at all.
        kbDebug("No variant picker after section swap; running fallbacks", { sectionId });
        document
          .querySelector("klaviyo-bis-form")
          ?.refreshFromDOM?.({ reason: "pdp-color-swatch-swap:no-picker", sectionId });
        return;
      }
      // Get product data from the new DOM
      let productData;
      try {
        productData = JSON.parse(variantComponent.querySelector('[type="application/json"]').textContent);
      } catch (e) {
        kbWarn("Unable to parse product JSON after section swap", e);
        return;
      }
      const variants = productData.variants;
      const options = productData.options;
      const sizeOptionIndex = options.findIndex((opt) => opt === "Size");
      const fitOptionIndex = options.findIndex((opt) => opt === "Fit");
      const styleOptionIndex = options.findIndex((opt) => opt === "Style");
      const lengthOptionIndex = options.findIndex((opt) => opt === "Length");

      // Restore size
      if (previousSelectedSize && sizeOptionIndex !== -1) {
        const sizeExists = variants.some((variant) => variant.options[sizeOptionIndex] === previousSelectedSize);
        if (sizeExists) {
          const sizeRadio = document.querySelector(
            `.product-form__input.size input[type="radio"][value="${previousSelectedSize}"]`,
          );
          if (sizeRadio && !sizeRadio.disabled) {
            sizeRadio.checked = true;
            sessionStorage.setItem("selectedSize", previousSelectedSize);
            // Update the size label
            const sizeLabel = document.querySelector("[data-size-label]");
            if (sizeLabel) {
              const sizeCurrentVariant = sizeLabel.querySelector(".form__current-variant");
              if (sizeCurrentVariant) {
                sizeCurrentVariant.classList.remove("hidden");
                sizeCurrentVariant.textContent = previousSelectedSize;
              }
            }
          }
        }
      }
      // Restore fit
      if (previousSelectedFit && fitOptionIndex !== -1) {
        const fitExists = variants.some((variant) => variant.options[fitOptionIndex] === previousSelectedFit);
        if (fitExists) {
          const fitRadio = document.querySelector(
            `.product-form__input.fit input[type="radio"][value="${previousSelectedFit}"]`,
          );
          if (fitRadio && !fitRadio.disabled) {
            fitRadio.checked = true;
            sessionStorage.setItem("selectedFit", previousSelectedFit);
            // Update the fit label
            const fitLabel = document.querySelector("[data-fit-label]");
            if (fitLabel) {
              const fitCurrentVariant = fitLabel.querySelector(".form__current-variant");
              if (fitCurrentVariant) {
                fitCurrentVariant.classList.remove("hidden");
                fitCurrentVariant.textContent = previousSelectedFit;
              }
            }
          }
        }
      }
      // Restore style
      if (previousSelectedStyle && styleOptionIndex !== -1) {
        const styleExists = variants.some((variant) => variant.options[styleOptionIndex] === previousSelectedStyle);
        if (styleExists) {
          const styleRadio = document.querySelector(
            `.product-form__input.style input[type="radio"][value="${previousSelectedStyle}"]`,
          );
          if (styleRadio && !styleRadio.disabled) {
            styleRadio.checked = true;
            sessionStorage.setItem("selectedStyle", previousSelectedStyle);
            // Update the style label
            const styleLabel = document.querySelector("[data-style-label]");
            if (styleLabel) {
              const styleCurrentVariant = styleLabel.querySelector(".form__current-variant");
              if (styleCurrentVariant) {
                styleCurrentVariant.classList.remove("hidden");
                styleCurrentVariant.textContent = previousSelectedStyle;
              }
            }
          }
        }
      }
      // Restore length
      if (previousSelectedLength && lengthOptionIndex !== -1) {
        const lengthExists = variants.some((variant) => variant.options[lengthOptionIndex] === previousSelectedLength);
        if (lengthExists) {
          const lengthRadios = document.querySelectorAll('.product-form__input.length input[type="radio"]');
          const lengthRadio = Array.from(lengthRadios).find((radio) => radio.value === previousSelectedLength);
          if (lengthRadio && !lengthRadio.disabled) {
            lengthRadio.checked = true;
            sessionStorage.setItem("selectedLength", previousSelectedLength);
            // Update the length label
            const lengthLabel = document.querySelector("[data-length-label]");
            if (lengthLabel) {
              const lengthCurrentVariant = lengthLabel.querySelector(".form__current-variant");
              if (lengthCurrentVariant) {
                lengthCurrentVariant.classList.remove("hidden");
                lengthCurrentVariant.textContent = previousSelectedLength;
              }
            }
          }
        }
      }

      // Trigger a change event to update the variant selection logic/UI
      variantComponent.dispatchEvent(new Event("change", { bubbles: true }));
    }, 0);

    // fix bug in Safari where srcset doesn't render correctly for images loaded asynchronously
    this.reloadSrcsetImgs(document);

    if (StampedFn) StampedFn.reloadUGC();

    // Keep the URL stable and valid.
    // - If we have a variant id from the swatch URL, use it.
    // - Otherwise, derive it from the newly-rendered product form.
    const resolvedVariantId = kbNormalizeVariantId(variantId) || kbGetVariantIdFromDom(sectionId);
    const nextUrl = resolvedVariantId ? `${parsedUrl.pathname}?variant=${resolvedVariantId}` : parsedUrl.pathname;
    window.history.replaceState({}, document.title, nextUrl);

    // Ensure BIS has the correct variant id even if no picker exists.
    document
      .querySelector("klaviyo-bis-form")
      ?.refreshFromDOM?.({ reason: "pdp-color-swatch-swap", sectionId, variantId: resolvedVariantId });

    kbDebug("PDP section swap complete", { sectionId, resolvedVariantId, nextUrl });

    if (window.setupPDPSizeChartContent) window.setupPDPSizeChartContent();
  }

  updateAddToCartButtonState(sizeRadioToCheck) {
    const selectedSize = sessionStorage.getItem("selectedSize");
    const addButton = document.getElementById(`product-form-${this.dataset.sectionId}`)?.querySelector('[name="add"]');
    const notifyMeButton = document.querySelector(".klaviyo-bis-trigger.button");
    const isDisabled = sizeRadioToCheck.classList.contains("disabled");

    if (addButton) {
      if (selectedSize && !isDisabled) {
        addButton.removeAttribute("disabled");
      } else {
        addButton.setAttribute("disabled", "disabled");
      }
    }

    if (notifyMeButton) {
      if (!selectedSize) {
        notifyMeButton.setAttribute("disabled", "disabled");
      } else if (selectedSize && isDisabled) {
        notifyMeButton.removeAttribute("disabled");
      } else {
        notifyMeButton.removeAttribute("disabled");
      }
    }
  }

  fetchSectionDataForAlternateColors(sectionIds, isBundle) {
    this.buttons.forEach((button) => {
      if (button.dataset.isSelected === "true") return;

      const parsedUrl = new URL(button.dataset.url, window.location.origin);
      parsedUrl.searchParams.set("sections", sectionIds.join(","));
      if (isBundle) {
        parsedUrl.searchParams.set("view", "bundle-source");
      }
      fetch(parsedUrl)
        .then((response) => response.json())
        .then((responseJson) => {
          this.cache[parsedUrl.toString()] = responseJson;
        })
        .catch(console.error);
    });
  }

  reloadSrcsetImgs(item) {
    var imgs = item.querySelectorAll("img[srcset]");
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.outerHTML = img.outerHTML;
    }
  }
}

customElements.define("pdp-color-swatches", PDPColorSwatches);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class CartDrawerUpsell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.url) {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("#shopify-section-cart-drawer-upsells");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
}

customElements.define("cart-drawer-upsell", CartDrawerUpsell);

class CardSwatchSwitcher extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll("button");
    this.buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleClick(e);
      });
    });

    this.showMoreButton = this.querySelector(".show-more-swatches");
    window.addEventListener("resize", debounce(this.handleResize.bind(this), 300));
    this.handleResize();
  }

  handleClick(e) {
    // Getting the "data-selected-sizes-instock" value of the current swatches
    let parent = e.target.closest(".card-swatch-switcher");
    let swatches = parent.querySelectorAll("button");
    let prev_swatch_status = [];
    swatches.forEach((swatch) => {
      let linkID = swatch.getAttribute("data-linked-product-id");
      let selectedSizesInStock = swatch.getAttribute("data-selected-sizes-instock");
      const swatchObject = {
        linkID,
        selectedSizesInStock,
      };
      prev_swatch_status.push(swatchObject);
    });

    const parsedUrl = new URL(e.target.closest("button").dataset.url, window.location.origin);
    parsedUrl.searchParams.set("section_id", "plp-card-product");

    fetch(parsedUrl)
      .then((response) => response.text())
      .then((responseText) => {
        this.renderNewSection(responseText, prev_swatch_status);
      })
      .catch(console.log);
  }

  findSelectedSizesInStock(linkID, array) {
    for (const product of array) {
      if (product["linkID"] === linkID) {
        return product["selectedSizesInStock"];
      }
    }
    return "";
  }

  renderNewSection(html, prev_swatch_status) {
    const destination = this.closest(".product-card-wrapper");
    const source = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("shopify-section-plp-card-product")
      .querySelector(".product-card-wrapper");

    // Get the "data-selected-sizes-instock" value of the previous swatches and assign it to the newly rendered swatches.
    try {
      if (prev_swatch_status && prev_swatch_status.length > 0) {
        let new_swatches = source.querySelectorAll(".card-swatch-switcher__swatch");
        new_swatches.forEach((swatch) => {
          let linkID = swatch.getAttribute("data-linked-product-id");
          let selectedSizesInStock = this.findSelectedSizesInStock(linkID, prev_swatch_status);
          swatch.setAttribute("data-selected-sizes-instock", selectedSizesInStock);
        });
      }
    } catch (e) {
      console.error("cannot update swatch attribute: data-selected-sizes-instock ");
    }
    // this.check_selected_sizes_in_stock(source)

    if (source && destination) {
      // hiding alt text when switching product imagery but leaving it on load so it's not penalized by Google -- Fix for firefox displaying alt text between switching
      source.querySelector("img").classList.add("hide-alt-text");
      destination.innerHTML = source.innerHTML;

      // removing the font size 0 after a brief timeout
      setTimeout(function () {
        destination.querySelector("img").classList.remove("hide-alt-text");
      }, 500);
    }

    // // fix bug in Safari where srcset doesn't render correctly for images loaded asynchronously
    // this.reloadSrcsetImgs(document);

    if (StampedFn) StampedFn.reloadUGC();
  }

  // check if selected sizes have stock
  check_selected_sizes_in_stock(source) {
    // get variants data
    let encodedData,
      decodedString,
      variantsData,
      optSizeIdx,
      are_these_sizes_instock,
      size_stock_counter = "";
    // let selectedSizes_arr = FacetFiltersForm.getActiveSizeSelections()

    try {
      encodedData = source.getAttribute("data-variants");
      optSizeIdx = source.getAttribute("data-option-size-index");
      decodedString = decodeURI(encodedData);
      variantsData = JSON.parse(decodedString);

      selected_sizes_arr.forEach((item) => {
        let selected_size = item.toLowerCase();
        for (let i = 0; i < variantsData.length; i++) {
          let variant = variantsData[i];
          let sizeVal;
          switch (optSizeIdx) {
            case 1:
              sizeVal = variant.option1.toLowerCase();
              break;
            case 2:
              sizeVal = variant.option2.toLowerCase();
              break;
            case 3:
              sizeVal = variant.option3.toLowerCase();
              break;
          }
          if (selected_size != sizeVal) {
            continue;
          } else {
            let variant_inventory = variant.inventory_quantity;
            if (variant_inventory < 1) {
              size_stock_counter = size_stock_counter.concat("1");
            } else if (variant_inventory > 0) {
              size_stock_counter = size_stock_counter.concat("0");
            }
          }
          if (!size_stock_counter.includes("0")) {
            are_these_sizes_instock = false;
          } else {
            are_these_sizes_instock = true;
          }
        }
      });
      if (selected_sizes_arr.length == 0) {
        are_these_sizes_instock = true;
      }
    } catch (e) {
      console.error("cannot parse data from .product-card-wrapper[data-variants]");
    }
  }

  reloadSrcsetImgs(item) {
    var imgs = item.querySelectorAll("img[srcset]");
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.outerHTML = img.outerHTML;
    }
  }

  handleResize() {
    const totalSwatches = this.showMoreButton.dataset.totalSwatches;
    const max = window.innerWidth <= 750 ? 10 : 12;

    this.showMoreButton.classList.toggle("hidden", totalSwatches <= max);
  }
}

customElements.define("card-swatch-switcher", CardSwatchSwitcher);

class KlaviyoBISForm extends HTMLElement {
  constructor() {
    super();

    this.url = "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=jhzhvR";

    this.form = this.querySelector("form");
    this.openTrigger = this.querySelector(".klaviyo-bis-trigger");

    // Defensive: BIS can exist on pages where we don't have a variant picker.
    // We still want the trigger to become usable when BIS is visible.
    if (this.form) this.form.addEventListener("submit", this.handleFormSubmit.bind(this));
    if (this.openTrigger) this.openTrigger.addEventListener("click", this.handleOpenForm.bind(this));
  }

  connectedCallback() {
    // Ensure the component initializes correctly on first load AND after section swaps.
    // Using a microtask keeps this lightweight and avoids layout thrash.
    queueMicrotask(() => this.refreshFromDOM({ reason: "connectedCallback" }));
  }

  /**
   * Sync the hidden variantId input + trigger enabled state.
   *
   * This method is intentionally safe to call repeatedly.
   * It is used as a fallback when variant selection logic is absent.
   */
  refreshFromDOM({ reason = "unknown", sectionId = null } = {}) {
    try {
      const disabledByTag = String(this.dataset.disabled) === "true";
      const inferredSectionId = sectionId || kbGetSectionIdFromElement(this);
      const variantIdInput = this.querySelector('input[name="variantId"]');

      // IMPORTANT: quick-add modals inject `MainProduct-*` innerHTML without the wrapper,
      // so `kbGetSectionIdFromElement()` returns null. If we fall back to `document`, we
      // could accidentally pick the *underlying page*'s product form.
      //
      // Scoping to the nearest `.product` container keeps this safe in quick-add, bundler,
      // and main PDP contexts.
      const nearestProductScope = this.closest(".product") || (inferredSectionId ? document.getElementById(`MainProduct-${inferredSectionId}`) : null);

      const variantId =
        kbNormalizeVariantId(variantIdInput?.value) ||
        kbNormalizeVariantId(this.dataset.initialVariantId) ||
        kbGetVariantIdFromScope(nearestProductScope) ||
        kbGetVariantIdFromDom(inferredSectionId);

      if (variantIdInput && variantId) {
        variantIdInput.value = variantId;
      }

      // Trigger should be usable only when BIS is visible, not disabled by tag,
      // and we have a variant id to submit.
      const isHidden = this.classList.contains("hidden");
      const shouldEnableTrigger = !disabledByTag && !isHidden && !!variantId;
      this.setTriggerEnabled(shouldEnableTrigger);

      // Historically, the theme used VariantSelects.updateKlaviyoBISForm() to also
      // hide/show other blocks when BIS is displayed.
      //
      // Default-variant products don't render a variant picker, so we duplicate that
      // behavior here as a reliable fallback.
      this.toggleKlaviyoHideTargets({ isBisVisible: !isHidden });

      kbDebug("Klaviyo BIS refresh", {
        reason,
        inferredSectionId,
        variantId,
        isHidden,
        disabledByTag,
        triggerEnabled: shouldEnableTrigger,
      });
    } catch (err) {
      kbError("Klaviyo BIS refresh failed", err);
    }
  }

  /**
   * Toggle elements that should disappear when BIS is shown.
   *
   * Elements opt-in via the `data-klaviyo-hide` attribute.
   * When BIS is visible (container is not `.hidden`), we add `.hidden` to targets.
   */
  toggleKlaviyoHideTargets({ isBisVisible }) {
    const scope = this.closest(".product") || document;
    const targets = scope.querySelectorAll("[data-klaviyo-hide]");
    if (!targets?.length) return;
    targets.forEach((element) => {
      element.classList.toggle("hidden", isBisVisible);
    });
    kbDebug("Klaviyo BIS toggled [data-klaviyo-hide]", { isBisVisible, count: targets.length });
  }

  setTriggerEnabled(enabled) {
    if (!this.openTrigger) return;
    if (enabled) {
      this.openTrigger.removeAttribute("disabled");
    } else {
      this.openTrigger.setAttribute("disabled", "disabled");
    }
  }

  handleOpenForm(event) {
    event.preventDefault();
    kbDebug("Klaviyo BIS open form");
    this.form.classList.remove("hidden");
    this.openTrigger.classList.add("hidden");
  }

  handleFormSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.form);
    const email = formData.get("email");
    const variantId = kbNormalizeVariantId(formData.get("variantId"));

    if (!variantId) {
      // This should never happen once refreshFromDOM() has run, but keep it safe.
      kbError("Klaviyo BIS submit blocked: missing variantId", { email });
      return;
    }

    kbDebug("Klaviyo BIS submit", { variantId });

    this.send(variantId, email);
  }

  send(variantId, email) {
    fetch(this.url, {
      method: "POST",
      headers: {
        accept: "application/json",
        revision: "2024-06-15",
        "content-type": "application/json",
      },
      body: JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: { data: { type: "profile", attributes: { email: email } } },
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: "$shopify:::$default:::" + variantId,
              },
            },
          },
        },
      }),
    })
      .then((response) => {
        kbDebug("Klaviyo BIS response", { ok: response.ok, status: response.status });
        if (!response.ok) kbWarn("Klaviyo BIS request returned non-OK", { status: response.status });
      })
      .finally(() => {
        this.querySelector(".klaviyo-bis-form-inner").classList.add("hidden");
        this.querySelector(".klaviyo-bis-success").classList.remove("hidden");
      })
      .catch((err) => {
        kbError("Klaviyo BIS request failed", err);
      });
  }
}

customElements.define("klaviyo-bis-form", KlaviyoBISForm);

let productBanner = document.querySelector(".product-banner");

if (productBanner) {
  document.documentElement.style.setProperty("--banner-height", productBanner.offsetHeight + "px");
}

if (!customElements.get("accordion-element")) {
  customElements.define(
    "accordion-element",
    class AccordionElement extends HTMLElement {
      constructor() {
        super();
        this.toggle = this.querySelector("[data-accordion-toggle]");
        this.content = this.querySelector("[data-accordion-content]");
        this.indicators = this.querySelectorAll("[data-accordion-indicator]");
        this.singleIndicator = this.querySelector("[data-single-indicator]") || null;
        this.indicatorTransition = this.querySelector("[data-transition]");
        this.indicatorTransition
          ? (this.indicatorTransition = this.indicatorTransition.getAttribute("data-transition"))
          : null;
        this.toggleSpeed = this.getAttribute("data-toggle-speed") || 250;
        this.content.style.transition = `max-height ${this.toggleSpeed}ms ease-in-out`;
        this.open = this.toggle.getAttribute("aria-expanded") === "true";
        this.closeOtherAccordions = this.getAttribute("data-close-other-accordions") || false;
        this.sectionId = this.getAttribute("data-section-id") || false;
        this.init();

        if (Shopify.designMode) {
          document.addEventListener("shopify:block:select", (e) => {
            if (document.querySelector(`[data-block-id="${e.detail.blockId}"]`)) {
              let accordion = document.querySelector(`[data-block-id="${e.detail.blockId}"]`);
              let toggle = accordion.querySelector("[data-accordion-toggle]");
              if (toggle && toggle.getAttribute("aria-expanded") === "false") {
                toggle.click();
              }
            }
          });
        }
      }

      init() {
        this.toggle.addEventListener("click", this.toggleAccordion.bind(this));

        // for when only a single indicator is provided for a transition.

        this.content.addEventListener("transitionend", (e) => {
          !this.open && this.content.classList.remove("active");
          this.content.style.maxHeight = null;
        });

        this.handleResize();
        // Commented this out. We want this to run once for automatically expanding content, but this is firing
        // on scroll for mobile devices because of browser components that get introduced on scroll, causing a resize event.
        // Makes the accordions close on scroll.
        // const that = this
        // window.addEventListener('resize', function () {
        //   // that.handleResize()
        // })
      }

      handleResize() {
        const width = window.innerWidth;
        if (width <= 768) {
          console.log(this.open);
          if (this.hasAttribute("data-expanded-mobile") && this.open == false) {
            this.open = true;
            this.openContent();
          } else if (!this.hasAttribute("data-expanded-mobile") && this.open == true) {
            this.open = false;
            this.closeContent();
          }
        } else if (width >= 769) {
          if (this.hasAttribute("data-expanded-desktop") && this.open == false) {
            this.open = true;
            this.openContent();
          } else if (!this.hasAttribute("data-expanded-desktop") && this.open == true) {
            this.open = false;
            this.closeContent();
          }
        }
      }

      openContent() {
        this.open = true;
        this.content.classList.add("active");

        if (this.singleIndicator && this.indicatorTransition) {
          this.singleIndicator.setAttribute("style", this.indicatorTransition);
        }

        if (this.closeOtherAccordions && this.sectionId) {
          let otherAccordions = document.querySelectorAll(
            `accordion-element[data-section-id="${this.sectionId}"] .accordion__toggle[aria-expanded="true"]`,
          );
          otherAccordions.forEach((button) => {
            button.click();
          });
        }

        this.toggle.setAttribute("aria-expanded", this.open);
        this.content.style.maxHeight = 0;
        setTimeout(() => {
          this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        }, 1);
      }

      closeContent() {
        this.open = false;
        this.toggle.setAttribute("aria-expanded", this.open);
        if (this.singleIndicator && this.indicatorTransition) {
          this.singleIndicator.setAttribute("style", "");
        }
        this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        setTimeout(() => {
          this.content.style.maxHeight = 0;
        }, 1);
        // 'active' class is removed on transitionend
      }

      toggleAccordion(e) {
        this.open ? this.closeContent() : this.openContent();
      }
    },
  );
}
